import { createAsyncThunk } from "@reduxjs/toolkit";
import publishingTemplatesAPIs from "services/api/publisher/publishingTemplatesAPIs";

export const listTemplate = createAsyncThunk("publishingTemplates/listTemplate", async (payload) => {
  try {
    const response = await publishingTemplatesAPIs.listTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createTemplate = createAsyncThunk("publishingTemplates/createTemplate", async (payload) => {
  try {
    const response = await publishingTemplatesAPIs.createTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    const errorMessage = error?.response?.data?.error?.message || error?.response?.data?.message;
    const message = Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage;
    const errorObj = { ...(error?.response?.data?.error || error), message };
    throw errorObj;
  }
});

export const updateTemplate = createAsyncThunk("publishingTemplates/updateTemplate", async (payload) => {
  try {
    const response = await publishingTemplatesAPIs.updateTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    const errorMessage = error?.response?.data?.error?.message;
    const message = Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage;
    const errorObj = { ...(error?.response?.data?.error || error), message };
    throw errorObj;
  }
});

export const deleteTemplate = createAsyncThunk("publishingTemplates/deleteTemplate", async (payload) => {
  try {
    const response = await publishingTemplatesAPIs.deleteTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error;
  }
});

export const getTemplateVariables = createAsyncThunk("publishingTemplates/getTemplateVariables", async (payload) => {
  try {
    const response = await publishingTemplatesAPIs.getTemplateVariables(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error;
  }
});

export const getTemplateVariableList = createAsyncThunk(
  "publishingTemplates/getTemplateVariableList",
  async (payload) => {
    try {
      const response = await publishingTemplatesAPIs.getTemplateVariableList(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data?.error;
    }
  },
);

export const getTemplate = createAsyncThunk("publishingTemplates/getTemplate", async (payload) => {
  try {
    const response = await publishingTemplatesAPIs.getTemplate(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error;
  }
});
